"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactstrap = require("reactstrap");
var _reactResponsive = require("react-responsive");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../../ui");
var _fields = require("../../../../fields");
var _ticker = require("../../../../ticker");
var _utils = require("../../../../../utils");
var _transactionInfo = require("./transaction-info");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Widget = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  visibility: ", ";\n  height: ", ";\n"])), function (_ref) {
  var loading = _ref.loading;
  return loading ? 'hidden' : 'visible';
}, function (_ref2) {
  var loading = _ref2.loading;
  return loading ? '0' : 'auto';
});
var CardField = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 8px 16px;\n  border-radius: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-size: 16px;\n  font-weight: 400;\n  &::placeholder {\n    color: ", ";\n  }\n  &:focus {\n    border-color: ", ";\n    color: ", ";\n    box-shadow: none;\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.radius.sm;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.secondaryShade;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.secondaryShade2;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.tertiaryShade;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.tertiary;
});
var H5 = (0, _styledComponents.default)(_ui.H5)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n"])));
var TransactionInfoGroup = (0, _styledComponents.default)(_ui.FormGroup)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-top: 30px;\n"])));
var SpinnerWrapper = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin: 20px 0;\n"])));
var CardFields = (0, _styledComponents.default)(_ui.Row)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), _utils.mediaQuery.lessThan('md')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    > div:first-child {\n      margin-bottom: 20px;\n    }\n  "]))), _utils.mediaQuery.lessThan('sm')(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    > div{\n      margin-bottom: 20px;\n    }\n  "]))));
var StyledAlert = (0, _styledComponents.default)(_ui.Alert)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin-top: 14px;\n  margin-bottom: 14px;\n"])));
var Component = function Component(_ref9) {
  var fiat = _ref9.fiat,
    balances = _ref9.balances;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  var isXlScreen = (0, _reactResponsive.useMediaQuery)({
    minWidth: _utils.breakpoints.xl
  });
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
    noValidate: true
  }, !fiat.isPaymentProviderSupported && /*#__PURE__*/_react.default.createElement(StyledAlert, {
    iconColor: "danger"
  }, t('fiatReplenishmentsNotWorkingAlert')), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('chooseCurrencyToReceive'), ":"), /*#__PURE__*/_react.default.createElement(_ticker.TickerSelectInput, {
    value: fiat.ticker,
    tickers: fiat.tickers,
    balances: balances,
    onChange: fiat.setTicker
  })), fiat.loadingWidget && /*#__PURE__*/_react.default.createElement(SpinnerWrapper, null, /*#__PURE__*/_react.default.createElement(_ui.Spinner, {
    color: "primary"
  })), /*#__PURE__*/_react.default.createElement(Widget, {
    loading: fiat.loadingWidget
  }, /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('enterAmount')), /*#__PURE__*/_react.default.createElement(_fields.TickerNumberFormatInputField, {
    control: fiat.formProps.control,
    inputProps: {
      name: 'amount',
      ticker: fiat.ticker
    }
  })), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(CardFields, null, /*#__PURE__*/_react.default.createElement(_ui.Col, {
    md: 4,
    sm: 12,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('cardNumber')), /*#__PURE__*/_react.default.createElement(CardField, {
    id: "card-number"
  }), /*#__PURE__*/_react.default.createElement(_ui.FormFeedback, {
    id: "error-card-number"
  })), /*#__PURE__*/_react.default.createElement(_ui.Col, {
    md: 3,
    sm: 4,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('cardExpireMonth')), /*#__PURE__*/_react.default.createElement(CardField, {
    id: "card-expire-month"
  }), /*#__PURE__*/_react.default.createElement(_ui.FormFeedback, {
    id: "error-card-expire-month"
  })), /*#__PURE__*/_react.default.createElement(_ui.Col, {
    md: 3,
    sm: 4,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('cardExpireYear')), /*#__PURE__*/_react.default.createElement(CardField, {
    id: "card-expire-year"
  }), /*#__PURE__*/_react.default.createElement(_ui.FormFeedback, {
    id: "error-card-expire-year"
  })), /*#__PURE__*/_react.default.createElement(_ui.Col, {
    md: 2,
    sm: 4,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('cardCVC')), /*#__PURE__*/_react.default.createElement(CardField, {
    id: "card-cvc"
  }), /*#__PURE__*/_react.default.createElement(_ui.FormFeedback, {
    id: "error-card-cvc"
  })))), !isXlScreen && /*#__PURE__*/_react.default.createElement(TransactionInfoGroup, null, /*#__PURE__*/_react.default.createElement(H5, null, t('transactionDetails')), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfo, null))), /*#__PURE__*/_react.default.createElement(_ui.Alert, null, t('replenishFiatAttention')));
};
exports.Component = Component;